import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import TransformUsers from './TransformUsers'
import PushData from './PushData'
import Store from './store'
import { Link } from 'react-router'

export default class extends Component {
  constructor(props) {
    super(props)
    const {
      params: { id }
    } = this.props
    this.store = new Store()
    this.store.getDetail(id)
  }
  render() {
    const header = [
      <Link to="/localMerchant/potentialCustomers?tab=2">推送列表</Link>,
      '推送详情'
    ]
    return (
      <HeaderView
        header={header}
        title="推送详情"
        contentStyle={{ paddingTop: 25 }}
      >
        <TransformUsers store={this.store} />
        <PushData store={this.store} />
      </HeaderView>
    )
  }
}
